const RoutingAction = {
    /** @type {string} **/
    path : '',

    /** @type {Function} **/
    enter : null,

    /** @type {Function} **/
    exit : null,

    /** @type {boolean} **/
    persistent : false,

    /** @type {boolean} **/
    active : false,
};

export default RoutingAction;



//////////////////
// WEBPACK FOOTER
// /Users/Jovan/TitanNanoDE/node_modules/@af-modules/router/lib/RoutingAction.js
// module id = 49
// module chunks = 0